import {ActionDock, ActionDockItem} from '@/shared/components/ui/ActionDock.tsx';
import {TOAST_CONFIG} from '@/shared/constants.ts';
import {Plus, X} from 'lucide-react';
import {useCallback, useState} from 'react';
import '@/shared/styles/FloatingActionButton.css';

type FloatingActionButtonProps = {
    onClick?: () => void;
    label?: string;
    actions?: ActionDockItem[];
};

export const FloatingActionButton = ({
    onClick,
    label = 'Registrar Serviço',
    actions,
}: FloatingActionButtonProps) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const handleClick = useCallback(() => {
        if ('vibrate' in navigator) {
            navigator.vibrate(TOAST_CONFIG.HAPTIC_DURATION_MS);
        }

        if (actions && actions.length > 0) {
            setIsExpanded((prev) => !prev);
        } else if (onClick) {
            onClick();
        }
    }, [onClick, actions]);

    const handleClose = useCallback(() => {
        setIsExpanded(false);
    }, []);

    const Icon = isExpanded ? X : Plus;

    return (
        <>
            {actions && actions.length > 0 && (
                <ActionDock actions={actions} isOpen={isExpanded} onClose={handleClose} />
            )}

            <button
                className={`fab ${isExpanded ? 'expanded' : ''}`}
                onClick={handleClick}
                aria-label={label}
                title={label}
                aria-expanded={actions ? isExpanded : undefined}
            >
                <Icon size={28} strokeWidth={2.5} className={isExpanded ? 'icon-rotate' : ''} />
            </button>
        </>
    );
};
